import { todayYMD } from ".";

export function formatClosureNoticeTitle(
  value: string,
  today: string = todayYMD()
): string {
  if (value === today) return "Hoje não terá agendamento";
  const day = Number(String(value || "").split("-")[2]);
  if (Number.isFinite(day) && day > 0) {
    return `Dia ${day} não terá agendamento`;
  }
  return "Não terá agendamento nesta data";
}
